<lib-modal #modal>
  <lib-modal-dialog class="force-upload-verification-modal">
    <lib-modal-dialog-header [hideCloseIcon]="true">
      <span>File already exist</span>
    </lib-modal-dialog-header>

    <lib-modal-dialog-body class="force-upload-verification-modal__body">
      <span class="force-upload-verification-modal__body-message">
        The {{ filename }} document already exists in the directory. Do you wish to overwrite it?
      </span>
    </lib-modal-dialog-body>

    <lib-modal-dialog-footer class="force-upload-verification-modal__footer">
      <lib-button
        class="force-upload-verification-modal__footer-button"
        (click)="onButtonClick(forceUploadVerificationModalActions.Yes)"
      >
        Yes
      </lib-button>

      <lib-button
        class="force-upload-verification-modal__footer-button"
        [type]="buttonType.Secondary"
        (click)="onButtonClick(forceUploadVerificationModalActions.No)"
      >
        No
      </lib-button>
    </lib-modal-dialog-footer>
  </lib-modal-dialog>
</lib-modal>
